// Signature Pergolas — Desktop filter bar (Phase 3, DL-303).
// Progressive enhancement only: every group already works via native <details>/checkboxes
// + a real Apply submit without this script. This adds accordion behaviour, outside-click
// and Escape-to-close, and the per-group Clear convenience button.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.sp-facets');
    if (!root) return;

    var groups = Array.prototype.slice.call(root.querySelectorAll('details.sp-facet'));

    groups.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          groups.forEach(function (other) {
            if (other !== d) other.open = false;
          });
        }
      });

      d.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && d.open) {
          d.open = false;
          var summary = d.querySelector('summary');
          if (summary) summary.focus();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        groups.forEach(function (d) { d.open = false; });
      }
    });

    root.querySelectorAll('[data-sp-facet-clear]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('.sp-facet__panel');
        if (!panel) return;
        panel.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
        panel.querySelectorAll('input[type="number"]').forEach(function (inp) { inp.value = ''; });
      });
    });
  });
})();

// ---- Mobile drawer (Phase 4, DL-401/402) ----
// Progressive enhancement only: the drawer's form is a real GET form ("Show N pergolas"
// submits it), so filtering works with JS off. This script adds open/close, scroll lock,
// focus trap, Escape/backdrop/back-button close, independent accordions, and the live
// count fetch (Section Rendering API) with a static fallback if the fetch fails.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('sp-mdrawer');
    var openBtn = document.querySelector('[data-sp-mdrawer-open]');
    if (!drawer || !openBtn) return;

    var panel = drawer.querySelector('.sp-mdrawer__panel');
    var closeEls = drawer.querySelectorAll('[data-sp-mdrawer-close]');
    var form = drawer.querySelector('[data-sp-mdrawer-form]');
    var showBtn = drawer.querySelector('[data-sp-mdrawer-show]');
    var htmlEl = document.documentElement;
    var ownsHistoryEntry = false;
    var lastFocused = null;

    function focusableEls() {
      return Array.prototype.slice.call(
        panel.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) { return el.offsetParent !== null; });
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var items = focusableEls();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        closeDrawer();
      } else {
        trapFocus(e);
      }
    }

    function openDrawer() {
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      htmlEl.classList.add('sp-mdrawer-lock');
      // Shopify's theme-preview bar (draft themes only) is drawn over the bottom of the
      // viewport and would cover the sticky footer; lift the panel above it. Absent on live.
      var previewBar = document.getElementById('PBarNextFrameWrapper');
      if (previewBar && panel) panel.style.paddingBottom = previewBar.offsetHeight + 'px';
      history.pushState({ spMdrawer: true }, '', location.href);
      ownsHistoryEntry = true;
      document.addEventListener('keydown', onKeydown);
      var closeBtn = drawer.querySelector('.sp-mdrawer__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      htmlEl.classList.remove('sp-mdrawer-lock');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
      if (ownsHistoryEntry) {
        ownsHistoryEntry = false;
        history.back();
      }
    }

    openBtn.addEventListener('click', openDrawer);
    closeEls.forEach(function (el) { el.addEventListener('click', closeDrawer); });
    window.addEventListener('popstate', function () {
      if (drawer.classList.contains('is-open')) {
        ownsHistoryEntry = false;
        closeDrawer();
      }
    });

    // Submitting "Show N pergolas" navigates away without going through closeDrawer(). Strip the
    // open/scroll-lock classes right before navigation so a bfcache'd copy of this page (reached
    // later via the browser's own Back button) doesn't reappear with the drawer stuck open.
    if (form) {
      form.addEventListener('submit', function () {
        drawer.classList.remove('is-open');
        htmlEl.classList.remove('sp-mdrawer-lock');
      });
    }

    // Accordions open independently (not auto-closing siblings, unlike the desktop pills).

    // Live count on "Show N pergolas" via Section Rendering API; static fallback on failure.
    if (form && showBtn) {
      var sectionId = form.getAttribute('data-section-id');
      var collectionUrl = form.getAttribute('data-collection-url');
      var debounceTimer = null;
      var controller = null;

      function updateLiveCount() {
        if (!sectionId || !collectionUrl) return;
        if (controller) controller.abort();
        controller = new AbortController();
        var params = new URLSearchParams(new FormData(form));
        params.set('section_id', sectionId);
        fetch(collectionUrl + '?' + params.toString(), { signal: controller.signal })
          .then(function (res) {
            if (!res.ok) throw new Error('bad status');
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var el = doc.querySelector('[data-sp-count]');
            var n = el ? parseInt(el.textContent.trim(), 10) : NaN;
            var noun = showBtn.getAttribute('data-noun');
            if (!isNaN(n) && noun) {
              showBtn.textContent = 'Show ' + n + ' ' + noun;
            }
          })
          .catch(function () { /* static fallback: leave the last known label as-is */ });
      }

      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], input[type="radio"], input[type="number"]')) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(updateLiveCount, 250);
        }
      });
    }
  });
})();
